var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsBgLayer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1769,
    height: 286,
    viewBox: "0 0 1769 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1769V280.948C1769 283.709 1766.76 285.948 1764 285.948H4.99999C2.23857 285.948 0 283.709 0 280.948V0Z",
    fill: "#0C3330"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1769,
    height: 286
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1769V280.948C1769 283.709 1766.76 285.948 1764 285.948H4.99999C2.23857 285.948 0 283.709 0 280.948V0Z",
    fill: "#0C3330"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2837.67 610.668C2712.66 1102.81 2214.74 1678.61 1702.66 1515.45C1190.58 1352.29 876.793 821.053 1001.8 328.907C1126.81 -163.239 1643.27 -429.933 2155.35 -266.77C2667.43 -103.608 2962.68 118.522 2837.67 610.668Z",
    fill: "#6DFFFE",
    fillOpacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsBgLayer1);
export default __webpack_public_path__ + "static/media/payments_bg_layer1.3fe651aeee1c87af493a0053232f6576.svg";
export { ForwardRef as ReactComponent };